import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Wordmark, Footer } from "@/components/Brand";

export default function BriefConfirm() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("invalid"); return; }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/brief/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((d) => setState(d.ok ? "confirmed" : (d.status || "invalid")))
      .catch(() => setState("invalid"));
  }, [params]);
  const copy = {
    loading: ["Confirming…", "One moment while we confirm your subscription."],
    confirmed: ["You're confirmed", "You'll get Sarge's Weekly Founder Command Brief each week. Watch for the first one soon."],
    expired: ["Link expired", "That confirmation link has expired. Subscribe again from the WarRoom AI site to get a fresh link."],
    invalid: ["Link not valid", "That confirmation link isn't valid. Subscribe again from the WarRoom AI site."],
  };
  const [title, body] = copy[state] || copy.invalid;
  return (
    <div className="min-h-screen bg-wr-bg flex flex-col" data-testid="brief-confirm-page">
      <header className="px-4 sm:px-8 py-6 border-b border-wr-border"><Wordmark /></header>
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md text-center">
          <h1 className="wr-heading text-2xl text-white mb-3" data-testid="brief-confirm-title">{title}</h1>
          <p className="text-wr-sub text-sm leading-relaxed mb-6" data-testid="brief-confirm-body">{body}</p>
          <Link to="/" className="wr-mono uppercase tracking-wider text-xs text-wr-red hover:underline" data-testid="brief-confirm-home">Go to WarRoom AI →</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
